import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import moment from "moment"
import ReactTable from "react-table"
import _ from "lodash"
import { Pie, HorizontalBar, Bar, Doughnut } from "react-chartjs-2"
import clone from "clone"
import lineOptions from "helpers/lineOptions"
import times from 'helpers/times'
import numeral from 'numeral'
import ImageExport from "components/ImageExport"
import ReactSelect from "components/ReactSelect"
import FullTable from "components/FullTable"

class DemographicsYoY extends Component {
	constructor(props) {
		super(props)
		this.year = new Date().getFullYear()
		this.state = {
			times: times(),
			activeLotTypes: [],
			hideFlags: {
				buyerAge: null,
				totalNumber: null,
				occupation: null,
				firstTime: null,
				movingWithin: null,
			},
			years: [(this.year - 1).toString(), this.year.toString()],
			buyerAge: [],
			totalNumber: [],
			occupation: [],
			firstTime: [],
			movingWithin: [],
		}
	}

	flipPDF = (name, value) => {
		let state = clone(this.state)
		state.hideFlags[name] = value
		this.setState({ hideFlags: state.hideFlags })
	}

	buyerAge = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let years = clone(this.state.years)
		let labels = ["18 - 24", "25 - 34", "35 - 44", "45 - 54", "55 - 64", "65+"]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.primary_age || v.sale_date < this.state.times.lastYear) {
				return
			}
			let year = moment.unix(v.sale_date).format("Y")
			if (year == years[0] && v.sale_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${v.primary_age}`)) {
				_.set(ret, `${year}.${v.primary_age}`, 0)
			}
			ret[year][v.primary_age]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.primary_age || v.bustout_date < this.state.times.lastYear) {
				return
			}
			let year = moment.unix(v.bustout_date).format("Y")
			if (year == years[0] && v.bustout_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${v.primary_age}`)) {
				_.set(ret, `${year}.${v.primary_age}`, 0)
			}
			ret[year][v.primary_age]--
		})
		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		///console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		// If previous year is 0, add 0 to the beginning of the array for previous year
		try {
			if (totals[years[0]] === 0) {
				d["18 - 24"].unshift(0)
				d["25 - 34"].unshift(0)
				d["35 - 44"].unshift(0)
				d["45 - 54"].unshift(0)
				d["55 - 64"].unshift(0)
				d["65+"].unshift(0)
			}
		} catch (e) {
			console.log(e)
		}
		
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				age: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			if(r[years[0]] === "NaN") r[years[0]] = 0
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			if (r[years[1]] === "NaN") r[years[1]] = 0
			// Percent
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t) || !isFinite(t)) {
					t = ""
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t) || !isFinite(t)) {
					t = ""
				}
				r["changed"] = t
			}
			//console.log(r)
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		const data = {
			labels: years,
			datasets: [
				{
					label: "18 - 24",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["18 - 24"],
				},
				{
					label: "25 - 34",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["25 - 34"],
				},
				{
					label: "35 - 44",
					backgroundColor: colorArray[3],
					borderColor: colorArray[3],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["35 - 44"],
				},
				{
					label: "45 - 54",
					backgroundColor: colorArray[4],
					borderColor: colorArray[4],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["45 - 54"],
				},
				{
					label: "55 - 64",
					backgroundColor: colorArray[5],
					borderColor: colorArray[5],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["55 - 64"],
				},
				{
					label: "65+",
					backgroundColor: colorArray[6],
					borderColor: colorArray[6],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["65+"],
				},
			],
		}

		const columns = [
			{
				Header: "Age",
				accessor: "age",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (!props.value) {
						return ""
					} else if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div
				className="statBox__row statBox__row--threeOne avoid"
				data-html2canvas-ignore={this.state.hideFlags.buyerAge}>
				<div className="statBox__box">
					<h3 className="statBox__title">Buyer Age</h3>
					<HorizontalBar data={data} options={lineOptions} />
				</div>
				<div className="statBox__box">
					<FullTable
						data={tableData}
						columns={columns}
						name="demoYoY__buyerAge"
						title="Buyer Age"
					/>
				</div>
			</div>
		)
	}

	totalNumber = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let years = [(this.year - 1).toString(), this.year.toString()]
		let labels = []
		let props = {}
		let max = 7
		for (let i = 1; i <= max; i++) {
			labels.push(i)
			props[i] = 0
		}
		// Build bucket, hadrer with number property names
		for (let row of years) {
			ret[row] = clone(props)
		}
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let year = moment.unix(v.sale_date).format("Y")
			if (year == years[0] && v.sale_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (
				!v.num_residents ||
				!years.includes(year) ||
				v.num_residents >= max ||
				v.sale_date < this.state.times.lastYear
			) {
				return
			}
			let num = v.num_residents.toString()
			ret[year][num]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let year = moment.unix(v.bustout_date).format("Y")
			if (year == years[0] && v.bustout_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (
				!v.num_residents ||
				!years.includes(year) ||
				v.num_residents >= max ||
				v.bustout_date < this.state.times.lastYear
			) {
				return
			}
			let num = v.num_residents.toString()
			ret[year][num]--
		})
		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (v >= max) {
					return
				}
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		// now create arrays of every year combo
		let setData = {}
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(setData, `${k}`)) {
					_.set(setData, `${k}`, [])
				}
				setData[k].push(value)

				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				total: parseInt(k),
			}
			r[years[0]] = parseFloat(((v[0] / totals[years[0]]) * 100).toFixed(2))
			if (isNaN(r[years[0]])) r[years[0]] = 0
			r[years[1]] = parseFloat(((v[1] / totals[years[1]]) * 100).toFixed(2))
			if (isNaN(r[years[1]])) r[years[1]] = 0
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t) || !isFinite(t)) {
					t = 0
				}
				r["changed"] = parseFloat(t)
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t) || !isFinite(t)) {
					t = 0
				}
				r["changed"] = parseFloat(t)
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})
		const data = {
			labels: labels,
			datasets: [
				{
					label: years[0],
					backgroundColor: colorArray[3],
					borderColor: colorArray[3],
					borderWidth: 1,
					data: Object.values(setData[years[0]]),
				},
				{
					label: years[1],
					backgroundColor: colorArray[6],
					borderColor: colorArray[6],
					borderWidth: 1,
					data: Object.values(setData[years[1]]),
				},
			],
		}

		const columns = [
			{
				Header: "Total",
				accessor: "total",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div
				className="statBox__row statBox__row--threeOne avoid"
				data-html2canvas-ignore={this.state.hideFlags.totalNumber}>
				<div className="statBox__box">
					<ImageExport name="TotalNumber" />
					<h3 className="statBox__title">Total # of Residents</h3>
					<Bar data={data} options={lineOptions} />
				</div>
				<div className="statBox__box">
					<FullTable data={tableData} columns={columns} name="demoYoY__totalResidents" title="Total Residents" />
				</div>
			</div>
		)
	}

	occupation = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let years = clone(this.state.years)
		let labels = this.props.payload.public.occupations
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let year = moment.unix(v.sale_date).format("Y")
			if (year == years[0] && v.sale_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!v.primary_occupation || !years.includes(year) || v.sale_date < this.state.times.lastYear) {
				return
			}
			let occupation = _.find(this.props.payload.public.occupations, { value: v.primary_occupation })
			if (!occupation) {
				return
			}

			if (!_.has(ret, `${year}.${occupation.label}`)) {
				_.set(ret, `${year}.${occupation.label}`, 0)
			}
			ret[year][occupation.label]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let year = moment.unix(v.bustout_date).format("Y")
			if (year == years[0] && v.bustout_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!v.primary_occupation || !years.includes(year) || v.bustout_date < this.state.times.lastYear) {
				return
			}
			let occupation = _.find(this.props.payload.public.occupations, { value: v.primary_occupation })
			if (!occupation) {
				return
			}

			if (!_.has(ret, `${year}.${occupation.label}`)) {
				_.set(ret, `${year}.${occupation.label}`, 0)
			}
			ret[year][occupation.label]--
		})
		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		//console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		//console.log(d)
		//console.log(totals)
		try {
			if (totals[years[0]] === 0) {
				_.forEach(d, (v, k) => {
					d[k].unshift(0)
				})
			}
		} catch (e) {
			console.log(e)
		}
		//console.log(d)
		
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				occupation: k,
			}
			r[years[0]] = v[0] ? parseFloat(v[0] / totals[years[0]]) * 100 : 0
			r[years[1]] = v[1] ? parseFloat(v[1] / totals[years[1]]) * 100 : 0
			if (r[years[0]] === 0 && r[years[1]] === 0) {
				return
			}
			//console.log(r)
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				//console.log(t)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = parseFloat(t)
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = parseFloat(t)
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})
		//console.log(tableData)
		const columns = [
			{
				Header: "Occupation",
				accessor: "occupation",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => numeral(props.value).format("0,0.00") + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => numeral(props.value).format("0,0.00") + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="statBox__row" data-html2canvas-ignore={this.state.hideFlags.occupation}>
				<div className="statBox__box">
					<h3 className="statBox__title">Occupation</h3>
					<FullTable data={tableData} columns={columns} name="demoYoY__occupation" title="Occupations" />
				</div>
			</div>
		)
	}

	firstTime = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let years = clone(this.state.years)
		let labels = ["No", "Yes"]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let l = v.first_time === 1 ? "Yes" : "No"
			let year = moment.unix(v.sale_date).format("Y")
			if (v.sale_date < this.state.times.lastYear) {
				return
			}
			if (year == years[0] && v.sale_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${l}`)) {
				_.set(ret, `${year}.${l}`, 0)
			}
			ret[year][l]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let l = v.first_time === 1 ? "Yes" : "No"
			let year = moment.unix(v.bustout_date).format("Y")
			if (v.bustout_date < this.state.times.lastYear) {
				return
			}
			if (year == years[0] && v.bustout_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${l}`)) {
				_.set(ret, `${year}.${l}`, 0)
			}
			ret[year][l]--
		})
		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		//console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		// create table data
		let tableData = []
		try {
			if (totals[years[0]] === 0) {
				d.No.unshift(0)
				d.Yes.unshift(0)
			}
		} catch (e) {
			console.log(e)
		}
		
		_.forEach(d, (v, k) => {
			let r = {
				first_time: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			if (r[years[0]] === "NaN") r[years[0]] = 0
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			if (r[years[1]] === "NaN") r[years[1]] = 0
			//console.log(r)
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		const data = {
			labels: years,
			datasets: [
				{
					label: "Yes",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["Yes"],
				},
				{
					label: "No",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["No"],
				},
			],
		}

		const columns = [
			{
				Header: "First Time",
				accessor: "first_time",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div
				className="statBox__row statBox__row--threeOne avoid"
				data-html2canvas-ignore={this.state.hideFlags.firstTime}>
				<div className="statBox__box">
					<ImageExport name="FirstTime" />
					<h3 className="statBox__title">First Time Buyer?</h3>
					<HorizontalBar data={data} options={lineOptions} />
				</div>
				<div className="statBox__box">
					<FullTable data={tableData} columns={columns} name="demoYoY__firstTime" title="First Time" />
				</div>
			</div>
		)
	}

	movingWithin = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let years = clone(this.state.years)
		let labels = ["No", "Yes"]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.sale_date < this.state.times.lastYear) {
				return
			}
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			let year = moment.unix(v.sale_date).format("Y")
			if (year == years[0] && v.sale_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${l}`)) {
				_.set(ret, `${year}.${l}`, 0)
			}
			ret[year][l]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.bustout_date < this.state.times.lastYear) {
				return
			}
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			let year = moment.unix(v.bustout_date).format("Y")
			if (year == years[0] && v.bustout_date > this.state.times.lastPoint) {
				// remove sales from last year past the point of ytd
				return
			}
			if (!_.has(ret, `${year}.${l}`)) {
				_.set(ret, `${year}.${l}`, 0)
			}
			ret[year][l]--
		})

		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		///console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		try {
			if (totals[years[0]] === 0) {
				d.No.unshift(0)
				d.Yes.unshift(0)
			}
		} catch (e) {
			console.log(e)
		}
		
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				is_moving_within: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			if (r[years[0]] === "NaN") r[years[0]] = 0
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			if (r[years[1]] === "NaN") r[years[1]] = 0
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = isFinite(t) ? t : 0
			}
			//console.log(r)
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		const data = {
			labels: years,
			datasets: [
				{
					label: "Yes",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["Yes"],
				},
				{
					label: "No",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["No"],
				},
			],
		}

		const columns = [
			{
				Header: "Moving Within",
				accessor: "is_moving_within",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div
				className="statBox__row statBox__row--threeOne avoid"
				data-html2canvas-ignore={this.state.hideFlags.movingWithin}>
				<div className="statBox__box">
					<ImageExport name="IsMovingWithin" />
					<h3 className="statBox__title">Is Moving Within?</h3>
					<HorizontalBar data={data} options={lineOptions} />
				</div>
				<div className="statBox__box">
					<FullTable data={tableData} columns={columns} name="demoYoY__movingWithin" title="Moving Within" />
				</div>
			</div>
		)
	}

	lotTypes = () => {
		let ret = []
		_.forEach(this.props.payload.public.lot_types, (v) => {
			if (this.props.activeProperties.includes(v.property)) {
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				let name = property.name || ""
				ret.push({
					label: this.props.activeProperties.length > 1 ? `${name} - ${v.name}` : `${v.name}`,
					value: v.id,
				})
			}
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="demographics">
					<div className="imageGroup">
						<Title title="YoY Demographics Report" showDate={false} hideFlags={this.state.hideFlags} />
						<div className="statBox">
							<div className="activeLotTypes__lotType">
								<h4>Active Lot Types:</h4>
								<ReactSelect
									name={`activeLotType`}
									options={this.lotTypes()}
									value={this.state.activeLotTypes}
									onBlur={() => {}}
									onChange={(k, v) => {
										if (!v) v = []
										this.setState({ activeLotTypes: v })
									}}
									isMulti
								/>
							</div>
						</div>
						<div className="statBox">
							{this.buyerAge()}
							{this.totalNumber()}
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox">
							{this.movingWithin()}
							{this.firstTime()}
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox">{this.occupation()}</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DemographicsYoY)
